import { getFirestore, collection, addDoc } from "firebase/firestore";

const SUPPORT_EMAIL = "pieterselashca@gmail.com";

const escapeHtml = (value = "") =>
  String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const stringifyDetails = (details) => {
  if (!details) {
    return "";
  }

  if (typeof details === "string") {
    return details;
  }

  try {
    return JSON.stringify(details, null, 2);
  } catch (error) {
    return String(details);
  }
};

export const sendPaymentIssueEmail = async ({
  subject = "Payment or Booking Issue Detected",
  reason,
  details,
  pendingBookingId,
  severity = "error",
} = {}) => {
  const safeReason = escapeHtml(reason || "Unknown issue.");
  const safeSeverity = escapeHtml(severity);
  const pendingBookingBlock = pendingBookingId
    ? `<p><strong>Pending Booking ID:</strong> ${escapeHtml(pendingBookingId)}</p>`
    : "";
  const detailContent = stringifyDetails(details);
  const detailBlock = detailContent
    ? [
        "<p><strong>Details:</strong></p>",
        `<pre style="background:#f5f5f5;padding:12px;border-radius:4px;white-space:pre-wrap;">${escapeHtml(
          detailContent
        )}</pre>`,
      ].join("")
    : "";

  const html = [
    "<p>Hello,</p>",
    "<p>A booking payment process encountered an issue in the Yavola platform.</p>",
    `<p><strong>Reason:</strong> ${safeReason}</p>`,
    `<p><strong>Severity:</strong> ${safeSeverity}</p>`,
    pendingBookingBlock,
    detailBlock,
    "<p>This is an automated alert generated by the booking system.</p>",
  ]
    .filter(Boolean)
    .join("");

  try {
    const db = getFirestore();
    const mailCollectionRef = collection(db, "mail");
    await addDoc(mailCollectionRef, {
      to: SUPPORT_EMAIL,
      message: {
        subject,
        html,
      },
    });
  } catch (error) {
    console.error("Failed to send payment issue email", error);
  }
};

export default sendPaymentIssueEmail;
